import { Box, Typography } from "@mui/material";
import { DispatchInfoBox } from "../../components/DOAForecastComponents/DispatchInfoBox";
import { DOAIconComp } from "../../components/DOAIconComp";
import { MainContainer } from "../../components/MainContainerComp";
import { AvailabilityStat } from "./DoaForecastData";
import { Status } from "./DoaForecastModels";

export interface IDoaForecastProps {
  onSelectDispatch: (dispatch: string, date: string) => void;
  data: AvailabilityStat[]
}

export const DoaForecast: React.FC<IDoaForecastProps> = ({
  onSelectDispatch,
  data
}) => (
  <MainContainer>
    <DOAIconComp />
    <Typography data-automation='doa-forecast-desc-text' sx={{ mt: 1, mb: 1, textAlign: 'center' }}>
      The Forecast Report will display DOA Statistics for a given date and dispatch.
    </Typography>
    <Typography
      component={'div'} 
      variant='container' 
      data-automation="data-container"
    >
      {
        data.map(((item, i) => (
          <Box sx={{ mb: 3 }} key={i} data-automation="data-container">
            <DispatchInfoBox
              date={item.dispatchDate}
              dispatch={item.dispatch}
              dispatchDescription={item.dispatchDescription}
              availabilityStatus={item.availabilityStatus as Status}
              dispatchStatus={item.physicalDispatchStatus as Status}
              onSelectDispatch={onSelectDispatch}
              rows={[['Jobs Required', item.jobRequired], ['Total Employees Using DOA System', item.totalEmployees]]}
            />
          </Box>
        )))
      }
    </Typography>
  </MainContainer>
) 